"use client";

import { env } from "@/env";
import { usePathname } from "@/i18n/navigation";
import dynamic from "next/dynamic";

const GoogleOneTapContent = dynamic(() => import("./GoogleOneTapContent"), {
  ssr: false,
});

const GOOGLE_CLIENT_ID = env.NEXT_PUBLIC_GOOGLE_CLIENT_ID;

/**
 * Paths where Google One Tap is blocked by default.
 * These can be enabled via feature flags for experimentation.
 */
const BLOCKED_PATHS = ["/", "/blog", "/agents", "/careers", "/contact-sales", "/conversational-ai", "/enterprise"];

function isBlockedPath(pathname: string): boolean {
  return BLOCKED_PATHS.some(path => pathname === path || pathname.startsWith(path + "/"));
}

export default function GoogleOneTap() {
  const pathname = usePathname();

  if (!GOOGLE_CLIENT_ID) {
    return null;
  }

  if (isBlockedPath(pathname)) {
    return null;
  }

  return <GoogleOneTapContent pathname={pathname} />;
}
